import * as sticky from 'jquery-sticky'

let stickyComponent = {
    init() {
        let paddingVal = $('main').css('padding-bottom')
        let headerH = parseInt($("header").height()) - 40;
        let footerH = parseInt($('footer').height()) + parseInt(paddingVal)
        let footerH2 = parseInt($('footer').height()) + parseInt($("#related-lots").height()) +40;

        const $element = $('aside #bid-bar')

        if ($element.length) {
            if ($(window).width() > 991) {
                $element.sticky({
                    topSpacing: headerH + 20,
                    bottomSpacing: footerH,
                })
            } else {
                $element.unstick()
            }
        }

        const $element2 = $('#lot-detail-content .pagination-lot-header')

        if ($element2.length) {
            $element2.sticky({
                topSpacing: headerH,
                bottomSpacing: footerH2,
            })
        }
        // const $element3 = $('.main-live-streaming-box')

        // if ($element3.length) {
        //     if ($(window).width() < 767 && window.innerHeight > window.innerWidth) {
        //         $element3.sticky({
        //             topSpacing: 0,
        //             bottomSpacing: 0,
        //         })
        //     } else {
        //         $element3.unstick()
        //     }
        // }
    },
}

$(() => {
    window.addEventListener('resize', stickyComponent.init)
    window.addEventListener('orientationchange', stickyComponent.init)

    stickyComponent.init()
})
